import { parse } from '@config/theme';
export const item = parse({
  display: 'grid',
  pb: '8',
  py: '64'
}, "ifpzbq4");
export const img = parse({}, "ifzawqe");
export const contentContainer = parse({}, "c6gi1g3");
export const list = "lquk7tc";
export const tag = parse({
  px: '3',
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  mr: '3'
}, "t1vd56wu");

require("./ChangeLogItem.styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./ChangeLogItem.styles.ts");